import Instagram from '../../src/legacy/Instagram';
export default Instagram;
